/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from 'react'
import { ThemeProvider } from 'theme-ui'
import { defineCustomElements } from '@ecotricity/web-components/loader'

import { theme } from './src/styles/theme'
import { WebpProvider } from './src/context/webp'
import { YouTubeProvider } from './src/context/youtube'
import { initWebVitals, trackRouteChange } from './src/utils/webVitals'
import { isStepNavigation } from './src/forms/wizard/router/step-url'

defineCustomElements()

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>
    <WebpProvider>
      <YouTubeProvider>
        {element}
      </YouTubeProvider>
    </WebpProvider>
  </ThemeProvider>
)

export const shouldUpdateScroll = ({ routerProps }) => {
  // A wizard step change is a route change on the same page: the wizard
  // scrolls to the top of the form itself (below the sticky header), so
  // neither the page-top scroll below nor Gatsby's own position restore
  // must run for it.
  if (isStepNavigation(routerProps.location.state)) return false
  if (!routerProps.location.hash) {
    window.scroll({
      top: 0,
      left: 0,
    })
    return false
  }
}

export const onInitialClientRender = () => {
  window.dispatchEvent(new Event('hydrated'))
  window.__hydrated = true
  trackRouteChange(window.location?.pathname)
  initWebVitals()
}

export const onRouteUpdate = ({ location }) => {
  trackRouteChange(location.pathname, { isClientNavigation: true })
}